/* YourXI print layout templates. C10 is the LIVE print layout (15 Oct 2026).
 * --------------------------------------------------------------------------
 * A template is one complete spacing + sizing system for the 900 x 1200 print
 * (1 unit = 12 in / 900 = 0.339 mm on 12x16, 0.508 mm on 18x24).
 * Numbers for "A" are measured off the original PSDs (BAR, SPA, REAL, JUVE,
 * PSV, LEIC, CHELDBL, MIAMI), see ../../ORIGINAL_SPEC.md. 1 A3 px = 0.22402 u.
 *
 * LIVE since 15 Oct 2026: template C10 (see active()). No URL switch on the live builder.
 * The same renderPrint() feeds screen, share image and print file, so whatever
 * a template draws here is exactly what prints.
 */
(function (root) {
  var ORIGINAL_FOOT = { head: 11.5, name: 9.55, lead: 10.5, headGap: 17, top: 1029, lcx: 236, rcx: 664, rk: 0.86, mgrGap: 6 };
  var BASE = {
    // pitch: outer edge of the original pitch = x 90.9-809.8, y 261.4-1008.5, line #F8F8F8, about 5.6 u
    pitch: { k: 0.979, top: 261.4, line: '#F8F8F8' },
    // title (personalise.js layoutTitle tokens): top line Regular 165 px = 37 u, main ExtraBold 212-285 px = 47.5-64 u, leading 1.0
    title: { topSize: 37, topWeight: 400, topTrack: 0, mainSize: 50, mainTrack: -0.01, pitch: 1.0, topToMain: 50.4, width: 760, centerY: 170, minTop: 60, maxBottom: 240 },
    logo: { w: 84.5, top: 1073.5 },
    foot: ORIGINAL_FOOT,
    // rows: shirt-art top of the GK and of the front line (LEIC 4-4-2: 891.6 / 298.6, the rows between spread evenly)
    rows: { gkTop: 891.6, frontTop: 298.6, minClear: 5 },
    reserveFirst: true
  };
  function T(o) { var t = JSON.parse(JSON.stringify(BASE)); for (var k in o) { if (o[k] && typeof o[k] === 'object' && !Array.isArray(o[k]) && t[k]) { for (var j in o[k]) t[k][j] = o[k][j]; } else t[k] = o[k]; } return t; }

  var TEMPLATES = {
    A: T({ id: 'A', label: 'A  Faithful',
      note: 'Exactly the original: 82.7 u shirts, first name Regular 11 u, surname Bold 16.1 u, 15.9 u between baselines, columns 161 u.',
      shirtW: 82.7, nameGap: 20.4, first: { size: 11.0, weight: 400, track: 0 }, last: { size: 16.1, weight: 700, track: 0 }, lineGap: 15.9,
      lastMin: 11.5, firstMin: 8.5, gutter: 14, cols: { 1: 0, 2: 161.3, 3: 190, 4: 161.3, 5: 140 } }),
    B: T({ id: 'B', label: 'B  Faithful + airy',
      note: 'Original type sizes, shirts 10% smaller, wider columns and a bigger gutter, so long names rarely need to shrink.',
      shirtW: 74.5, nameGap: 18.5, first: { size: 11.0, weight: 400, track: 0.2 }, last: { size: 16.1, weight: 700, track: 0 }, lineGap: 15.9,
      lastMin: 11.5, firstMin: 8.5, gutter: 18, cols: { 1: 0, 2: 200, 3: 215, 4: 174, 5: 147 },
      rows: { gkTop: 897, frontTop: 296, minClear: 8 } }),
    C: T({ id: 'C', label: 'C  Bold',
      note: 'Surnames 24% bigger (20 u ExtraBold), first names 12.5 u, auto-fit per name, original shirts.',
      shirtW: 80, nameGap: 19, first: { size: 12.5, weight: 400, track: 0 }, last: { size: 20, weight: 800, track: -0.015 }, lineGap: 19.5,
      lastMin: 12.5, firstMin: 9, gutter: 10, cols: { 1: 0, 2: 180, 3: 200, 4: 166, 5: 143 },
      title: { mainSize: 54 }, foot: { head: 12.5, name: 10.5, lead: 11.6, headGap: 18.5, top: 1032, lcx: 236, rcx: 664, rk: 0.95, mgrGap: 6 },
      rows: { gkTop: 882, frontTop: 298.6, minClear: 5 } }),
    D: T({ id: 'D', label: 'D  Compact names',
      note: 'Surnames 15% smaller (13.7 u), first names 9.6 u, shirts 15% bigger (95 u): the kits lead.',
      shirtW: 95, nameGap: 16, first: { size: 9.6, weight: 400, track: 0.2 }, last: { size: 13.7, weight: 700, track: 0 }, lineGap: 13.6,
      lastMin: 10, firstMin: 8, gutter: 10, cols: { 1: 0, 2: 161.3, 3: 190, 4: 161.3, 5: 140 },
      rows: { gkTop: 882, frontTop: 292, minClear: 5 } })
  };

  // C+10 / C+20 (15 Oct: C chosen, with shirts AND names a bit bigger). Same system as C:
  // shirt, first name, surname, baseline gap and hem gap scaled; minimum size, columns, rows, pitch, title, footer, logo unchanged.
  function bigger(f, id, label) {
    var c = JSON.parse(JSON.stringify(TEMPLATES.C));
    c.id = id; c.label = label;
    c.note = 'C with shirts and names ' + Math.round((f - 1) * 100) + '% bigger. Same columns, rows, pitch, title, footer and minimum surname size (12.5) as C.';
    c.shirtW *= f; c.nameGap *= f; c.lineGap *= f; c.first.size *= f; c.last.size *= f;
    return c;
  }
  TEMPLATES.C10 = bigger(1.10, 'C10', 'C+10');
  TEMPLATES.C20 = bigger(1.20, 'C20', 'C+20');

  // kits.js draws on a 170 x 214 canvas with viewBox -4 -4 178 218; the hem sits at about y 196
  var KIT = { vbW: 178, vbH: 218, artW: 170, padTop: 4, hem: 196 };

  var _ctx = null;
  function measure(text, size, weight, trackEm) {
    if (!_ctx) _ctx = document.createElement('canvas').getContext('2d');
    _ctx.font = weight + ' ' + size + 'px Montserrat, sans-serif';
    return _ctx.measureText(text).width + Math.max(0, text.length - 1) * (trackEm || 0) * size;
  }
  // LIVE: locked "C+10" on 15 Oct 2026. It is always the print layout; the other sets stay only for reference.
  // The title block is centred in the white space between the top of the page (inside the 15 mm border, 44.33 u)
  // and the top of the original pitch (261.4 u), for 1- and 2-line titles, with or without the small top line.
  var LIVE = 'C10';
  var PAGE_TOP = 44.33;
  TEMPLATES.C10.title.centerY = (PAGE_TOP + TEMPLATES.C10.pitch.top) / 2;
  TEMPLATES.C10.title.minTop = PAGE_TOP + 10;
  TEMPLATES.C10.title.maxBottom = TEMPLATES.C10.pitch.top - 12;
  function active() { return TEMPLATES[LIVE]; }

  // name block geometry below the hem, for a given template (surname on one line)
  function nameDepth(t) { return t.nameGap + 0.70 * t.first.size + t.lineGap + 0.22 * t.last.size; }

  /* Slot positions. Returns [{x, y, s, shirtW, fine, role, top}] where top = shirt-art top.
     y keeps the builder's old anchor convention (art top = y - 82) so tap rings still line up. */
  function positions(t, formatId, formationId, P, names) {
    if (!P || !P.layoutSlots) return null;
    var B = P.BOX, raw = P.layoutSlots(formatId, formationId, { width: B.width, height: B.height });
    var F = P.getFormation(formatId, formationId), fmt = P.getFormat(formatId);
    // Every format uses one row system (Batch 12): players are grouped into rows by depth (within 60 u counts as the
    // same row, so a slightly staggered midfield is one row with one baseline), rows are spread evenly from the GK line
    // to the front line, and each row uses the same column spacing as 11-a-side for its player count.
    var order = raw.map(function (o, i) { return i; }).sort(function (a, b) { return raw[b].y - raw[a].y; });   // GK (deepest) first
    var rowOf = [], rows = [];
    order.forEach(function (i) {
      var last = rows[rows.length - 1];
      if (last && Math.abs(raw[last.ref].y - raw[i].y) <= 60) { last.items.push(i); }
      else rows.push({ ref: i, items: [i] });
      rowOf[i] = rows.length - 1;
    });
    rows.forEach(function (r) { r.items.sort(function (a, b) { return raw[a].x - raw[b].x; }); });
    var n = rows.length, gap = n > 1 ? (t.rows.gkTop - t.rows.frontTop) / (n - 1) : 0;
    // 11 and 9-a-side use the fixed C10 column spacing. The smaller formats keep their own hand-placed widths
    // (squeezed like 11-a-side), so a 2-2 or a diamond still uses the pitch instead of huddling in the middle.
    var small = fmt.id !== 'eleven' && fmt.id !== 'nine', kx = (t.cols[4] || 166) / 204.7;
    var xOf = function (i) {
      var r = rowOf[i], items = rows[r].items, c = items.length, k = items.indexOf(i);
      if (small) return 450 + (raw[i].x - B.width / 2) * kx;
      var sp = t.cols[c] != null ? t.cols[c] : Math.min(t.cols[5], 640 / Math.max(1, c - 1));
      return c === 1 ? 450 : 450 + (k - (c - 1) / 2) * sp;
    };
    // rows only constrain each other where players sit roughly above one another (always true for 11/9-a-side;
    // in a diamond the wide pair and the centre player don't stack, so their shirts need not shrink)
    var stacked = !small || rows.some(function (r, ri) { var nx = rows[ri + 1]; return nx && r.items.some(function (a) { return nx.items.some(function (b) { return Math.abs(xOf(a) - xOf(b)) < 220; }); }); });
    // shirts shrink only if the rows are too close for shirt + names (4-2-3-1 etc.)
    var artH = t.shirtW * KIT.hem / KIT.artW;
    var maxArtH = gap - t.rows.minClear - nameDepth(t);
    var shirtW = n > 1 && stacked && artH > maxArtH ? Math.max(56, maxArtH * KIT.artW / KIT.hem) : t.shirtW;
    var out = raw.map(function (o, i) {
      var r = rowOf[i], c = rows[r].items.length, sp = c > 1 ? Math.abs(xOf(rows[r].items[1]) - xOf(rows[r].items[0])) : 0;
      var x = xOf(i);
      var top = t.rows.gkTop - r * gap;
      return { x: x, y: top + 82, s: 1, shirtW: shirtW, top: top, fine: o.fine, role: o.role, row: r, spacing: sp };
    });
    // available name width per slot: gap to the nearest name block that could share its height
    out.forEach(function (p, i) {
      var g = 1e9;
      out.forEach(function (q, j) { if (j !== i && Math.abs(q.top - p.top) < 60) g = Math.min(g, Math.abs(q.x - p.x)); });
      var edge = 2 * Math.min(p.x - 18, 882 - p.x);
      p.nameW = Math.max(60, Math.min(g === 1e9 ? 340 : g - t.gutter, edge, 340));
    });

    // a surname that has to wrap onto 2 lines makes its name block one line taller: if any does, make room by
    // shrinking the shirts (never the gaps), so a 2-line name can never touch the shirt in the row below
    if (names && n > 1 && stacked) {
      var two = out.some(function (p, i) { return names[i] && fitLast(t, names[i], p.nameW).lines.length > 1; });
      var maxArt2 = gap - t.rows.minClear - nameDepth(t) - t.last.size * 1.02;
      if (two && t.shirtW * KIT.hem / KIT.artW > maxArt2) {
        var sw2 = Math.min(shirtW, Math.max(56, maxArt2 * KIT.artW / KIT.hem));
        out.forEach(function (p) { p.shirtW = sw2; });
      }
    }
    return out;
  }

  // fit a surname: one line if it fits at >= lastMin, else the bigger of (2 lines) and (1 line below min). Never wider than w.
  function fitLast(t, text, w) {
    var size = t.last.size, wt = t.last.weight, tr = t.last.track;
    var w1 = measure(text, size, wt, tr), s1 = w1 > w ? size * w / w1 : size;
    if (s1 >= t.lastMin) return { lines: [text], size: s1 };
    var cands = [], re = /[ \-]/g, m;
    while ((m = re.exec(text))) { var a = text.slice(0, m.index + (m[0] === '-' ? 1 : 0)).trim(), b = text.slice(m.index + 1).trim(); if (a && b) cands.push([a, b]); }
    var best = null;
    cands.forEach(function (c) { var mw = Math.max(measure(c[0], size, wt, tr), measure(c[1], size, wt, tr)); if (!best || mw < best.mw) best = { c: c, mw: mw }; });
    var s2 = best ? Math.min(size, size * w / best.mw) : 0;
    if (best && s2 > s1) return { lines: best.c, size: s2 };
    return { lines: [text], size: s1 };
  }
  function fitFirst(t, text, w) {
    var size = t.first.size, w1 = measure(text, size, t.first.weight, t.first.track);
    return w1 > w ? size * w / w1 : size;
  }

  /* One slot, drawn in slot-local units (the <g> is translated to (x, y) with scale 1).
     ctx: {player, i, pos, PC, esc, nest, shirt, empty, label, captainOn, MX, PZ, style} */
  function slotSVG(t, ctx) {
    var p = ctx.pos, x = ctx.player, esc = ctx.esc, PC = ctx.PC;
    var bw = p.shirtW * KIT.vbW / KIT.artW, bh = bw * KIT.vbH / KIT.vbW, sc = bw / KIT.vbW;
    var artTop = -82, boxTop = artTop - KIT.padTop * sc, hem = boxTop + (KIT.padTop + KIT.hem) * sc;
    var firstBase = hem + t.nameGap + 0.70 * t.first.size;
    var lastBase = firstBase + t.lineGap;
    if (!x) {
      return '<g class="inner"><g class="empty-shirt" opacity=".95">' + ctx.nest(ctx.empty, -bw / 2, boxTop, bw, bh) + '</g>' +
        '<path d="M-' + (bw * .1).toFixed(1) + ' ' + (artTop + bh * .45).toFixed(1) + ' H' + (bw * .1).toFixed(1) + ' M0 ' + (artTop + bh * .45 - bw * .1).toFixed(1) + ' V' + (artTop + bh * .45 + bw * .1).toFixed(1) + '" stroke="' + PC.muted + '" stroke-width="2.4" stroke-linecap="round"/>' +
        '<text class="ptext" y="' + firstBase.toFixed(1) + '" text-anchor="middle" font-size="' + (t.first.size * 1.05).toFixed(1) + '" font-weight="500" fill="' + PC.muted + '" letter-spacing="1">' + esc(ctx.label) + '</text></g>';
    }
    var first = ctx.first, last = ctx.last;
    var fs = first ? fitFirst(t, first, p.nameW) : 0;
    var L = fitLast(t, last, p.nameW);
    if (!first && !t.reserveFirst) lastBase = hem + t.nameGap + 0.70 * L.size;
    var halo = PC.halo || PC.bg;
    var txt = function (y, size, w, tr, s, mode) {
      return '<text class="ptext" y="' + y.toFixed(1) + '" text-anchor="middle" font-size="' + size.toFixed(2) + '" font-weight="' + w + '"' + (tr ? ' letter-spacing="' + (tr * size).toFixed(2) + '"' : '') +
        (mode === 'halo' ? ' fill="' + halo + '" stroke="' + halo + '" stroke-width="' + (size * 0.32).toFixed(1) + '" stroke-linejoin="round" aria-hidden="true"' : ' fill="' + PC.ink + '"') + '>' + esc(s) + '</text>';
    };
    var lines = L.lines.map(function (s, k) { return { y: lastBase + k * L.size * 1.02, s: s }; });
    var names = '';
    ['halo', 'ink'].forEach(function (mode) {
      if (first) names += txt(firstBase, fs, t.first.weight, t.first.track, first, mode);
      lines.forEach(function (l) { names += txt(l.y, L.size, t.last.weight, t.last.track, l.s, mode); });
    });
    var bottom = lines[lines.length - 1].y, extra = '';
    if (ctx.PZ && x.nickname) { var ny = ctx.PZ.nicknameBaseline(bottom, L.size); extra += ctx.PZ.renderNickname(x.nickname, { x: 0, y: ny, nameSize: L.size, style: ctx.style }); bottom = ny; }
    if (ctx.MX && x.match) extra += ctx.MX.renderPlayerAnnotations(x.match, { x: 0, nameBottom: bottom, nameSize: L.size, style: ctx.style, after: x.nickname ? 'nickname' : undefined });
    root.YXI_TPL_INFO = root.YXI_TPL_INFO || {};
    root.YXI_TPL_INFO[ctx.i] = { last: last, size: +L.size.toFixed(2), lines: L.lines.length, firstSize: +fs.toFixed(2), nameW: +p.nameW.toFixed(1), shirtW: +p.shirtW.toFixed(1) };
    return '<g class="inner">' + ctx.nest(ctx.shirt, -bw / 2, boxTop, bw, bh) + (ctx.number || '') + (ctx.cap || '') + '<g class="names">' + names + extra + '</g></g>';
  }

  function pitchTransform(t, B) { // scale the builder's pitch box about the page centre, top edge to the original top
    var k = t.pitch.k, outerTop = B.y - 3;
    return 'translate(' + (450 - 450 * k).toFixed(2) + ' ' + (t.pitch.top - outerTop * k).toFixed(2) + ') scale(' + k + ')';
  }

  root.YXITpl = { TEMPLATES: TEMPLATES, active: active, positions: positions, slotSVG: slotSVG, measure: measure, fitLast: fitLast, pitchTransform: pitchTransform, KIT: KIT };
})(this);
